function estimateReadingTime(text) {
  // reading speed: 2.5 words per second (spoken Turkish average)
  const WORDS_PER_SECOND = 2.5;
  const COMMA_PAUSE = 0.15; // seconds
  const PERIOD_PAUSE = 0.3; // seconds

  // count words (remove punctuation for word count)
  const words = text
    .replace(/[.,!?;]/g, "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  const wordCount = words.length;

  // count punctuation pauses
  const commaCount = (text.match(/,/g) || []).length;
  const periodCount = (text.match(/[.!?]/g) || []).length;

  const secondsFromWords = wordCount / WORDS_PER_SECOND;
  const secondsFromPauses =
    commaCount * COMMA_PAUSE + periodCount * PERIOD_PAUSE;

  const totalSeconds = secondsFromWords + secondsFromPauses;

  return totalSeconds;
}

/**
 * Calculate estimated time based on voice texts
 * @param {Array} newsItems - Array of news items with voiceText property
 * @returns {string} Formatted estimated time (e.g., "2m 30s", "45s", "1m")
 */
export function calculateEstimatedTime(newsItems) {
  return (newsItems || [])
    .reduce((total, news) => {
      const voiceText = news?.voiceText || "";
      return total + estimateReadingTime(voiceText);
    }, 0)
    .toFixed(2);
}

export function formatEstimatedTime(totalSeconds) {
  if (totalSeconds === 0) return "0s";
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes === 0) return `${seconds}s`;
  if (seconds === 0) return `${minutes}m`;
  return `${minutes}m ${seconds}s`;
}

/**
 * Calculate estimated time for a single news item
 * @param {Object} news - News item with voiceText property
 * @returns {string} Formatted estimated time
 */
export function calculateSingleNewsEstimatedTime(news) {
  return calculateEstimatedTime([news]);
}
